<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/produtos/datatable'"
            actionFild
            @selectRow="visualizar"
            @visualizar="visualizar"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            columns: [
                {
                    label: 'Cod',
                    field: 'id',
                    order: 'produtos.id',
                    sort: 'asc'
                },
                {
                    label: 'Nome',
                    field: 'nome',
                    sort: 'asc'
                },
                {
                    label: 'Categoria',
                    field: 'categoria_nome',
                    order: 'categ_produtos.nome',
                    sort: 'asc'
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'produtos.valor',
                    sort: 'asc'
                },
                {
                    label: 'Custo de produção',
                    field: 'custo_producao_br',
                    order: 'produtos.custo_producao',
                    sort: 'asc'
                },
                {
                    label: 'Percentual de lucro',
                    field: 'percentual_lucro_br',
                    order: 'produtos.percentual_lucro',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'visualizar',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                },
            ]
    	}
	},
    methods: {
        visualizar(dado){
            this.$emit('show', dado.id);
        }
    }
}
</script>